import ServiceRestApi from "./service-rest-api";

class TaskService {

    //GET TASKS TO BE DEALED
    getTasks = () => {
        return ServiceRestApi.get(`/api/interventions-task`);
    }

    //GET TASK MESSAGES
    getTaskMessages = (taskId) => {
        return ServiceRestApi.get(`/api/messages?intervention-id=${taskId}`);
    }

    //UPDATE TASK STATUS
    updatetaskStatus = ({ taskId, status, view = "task", wilaya, payload }) => {
        return ServiceRestApi.post(`/api/intervention-status?intervention-id=${taskId}&status-id=${status}&view=${view}${wilaya ? `&wilaya=${wilaya}` : ``}`, payload)
    }

    //LAZY FETCHING MESSAGES
    getLazyMessages = (taskId, pageIndex, pageSize = 20) => {
        return ServiceRestApi.get(`/api/messages?intervention-id=${taskId}&page-size=${pageSize}&page-index=${pageIndex}`);
    }

    //LAZY FETCHING TASKS TO BE DEALED
    getLazyTasks = (pageIndex, pageSize = 50) => {
        return ServiceRestApi.get(`/api/interventions-task?page-size=${pageSize}&page-index=${pageIndex}`);
    }

    //GET TASK CHRONOLOGY
    getChronology = (taskId) => {
        return ServiceRestApi.get(`/api/intervention-chronology?intervention-id=${taskId}`);
    }

    //GET AVAILABLE TAGS
    getTags = (description) => {
        return ServiceRestApi.get(`/api/intervention-tag?description=${description}`)
    }

    //GET DEFER RANGE TIME ITEMS
    getDeferRangeTimeItems = () => {
        return ServiceRestApi.get(`/api/interventions-defer-time-range`);
    }

    //SYNC ATTACHMENT CDN LINK
    syncronizeAttachment = (messageId) => {
        return ServiceRestApi.get(`/api/synchronise-attachment?message-id=${messageId}`);
    }

    /*********************************** INTERVENTION TAGS CRUD ENDPOINTS ****************************************/
    //GET ALL INTERVENTION TAGS
    getTags = () => {
        return ServiceRestApi.get(`/api/intervention-tag`);
    }

    //ADD NEW INTERVENTION TAG
    addInterventionTag = (payload) => {
        return ServiceRestApi.post(`/api/intervention-tag`, payload);
    }

    //PATCH INTERVENTION TAG
    updateInterventionTag = (payload) => {
        return ServiceRestApi.patch(`api/intervention-tag`, payload);
    }

    //DELETE INTERVENTION TAG
    deleteInterventionTag = (payload) => {
        return ServiceRestApi.delete(`/api/intervention-tag`, { data: payload });
    }

    /**
     * Fetch on going Tasks, This should be temporary alternative fetching from folders view
     * @returns Axios.HttpResponse
     */
    getOngoingTasks = () => {
        return ServiceRestApi.get(`/api/interventions?view=folder&folder-id=1&sort=DESC&page-size=100&page-index=0`);
    }

    /**
     * Fetch Transfered Tasks, This should be temporary alternative fetching from folders view
     * @returns Axios.HttpResponse
     */
     getTransferedTasks = () => {
        return ServiceRestApi.get(`/api/interventions?view=folder&folder-id=5&sort=DESC&page-size=100&page-index=0`);
    }

}
export default new TaskService();